import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import Layout from './app/layout';
import Contact from './app/routes/contact';
import CourseDetail from './app/routes/course-detail';
import Courses from './app/routes/courses';
import Home from './app/routes/home';
import InstructorDetail from './app/routes/instructor-detail';
import Instructors from './app/routes/instructors';
import NotFound from './app/routes/not-found';
import ThankYou from './app/routes/thank-you';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="courses" element={<Courses />} />
            <Route path="courses/:slug" element={<CourseDetail />} />
            <Route path="instructors" element={<Instructors />} />
            <Route path="instructors/:slug" element={<InstructorDetail />} />
            <Route path="contact" element={<Contact />} />
            <Route path="thank-you" element={<ThankYou />} />

            <Route path="ar" element={<Navigate to="/" replace />} />
            <Route path="en" element={<Navigate to="/" replace />} />

            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
